/**
 * SCRUM-397 — redondeo general del precio de venta a nivel Negocio.
 * No es cosmético: el valor redondeado reemplaza el precio real usado en
 * tienda online, POS y checkout (ver uso en storefront-online-price-list.ts).
 */
export type PriceRoundingMode = "none" | "10" | "100";

export function roundPrice(value: number | null, mode: PriceRoundingMode | null | undefined): number | null {
  if (value == null) return value;
  if (mode === "10") return Math.round(value / 10) * 10;
  if (mode === "100") return Math.round(value / 100) * 100;
  return value;
}

export function roundPriceFields<T extends { precioUnitario: number | null; precioPorKg: number | null }>(
  fields: T,
  mode: PriceRoundingMode | null | undefined,
): T {
  if (!mode || mode === "none") return fields;
  return {
    ...fields,
    precioUnitario: roundPrice(fields.precioUnitario, mode),
    precioPorKg: roundPrice(fields.precioPorKg, mode),
  };
}
